import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import React from 'react';
interface CmsContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  as?: React.ElementType;
}
export function CmsContainer(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      as: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const Component = t1 === undefined ? "div" : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("page-container", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== Component || $[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <Component className={t2} {...props}>{children}</Component>;
    $[7] = Component;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}